import React from 'react';
import styled from 'styled-components';
import { MdWarningAmber } from 'react-icons/md';

const pitfalls = [
  {
    title: 'Skimping on Context',
    desc: 'Give background, not just the ask.'
  },
  {
    title: 'One-and-Done Mentality',
    desc: 'Plan for 2-3 iterations; first drafts are seldom perfect.'
  },
  {
    title: 'Over-stuffed Prompts',
    desc: 'Break a 10-step ask into smaller chunks the model can tackle.'
  },
  {
    title: 'Token-Limit Blindness',
    desc: 'Large uploads can silently truncate. Chunk long docs or ask for progressive summaries.'
  },
  {
    title: 'Blind Trust',
    desc: 'Fact-check numbers, sources, and code. LLMs can sound confident while being wrong.'
  },
  {
    title: 'Privacy Slips',
    desc: 'Strip personal, proprietary, or client data unless you know the provider\'s retention policy.'
  }
];

const SectionContainer = styled.section`
  margin: 2.5rem 0 0 0;
`;
const Title = styled.h3`
  margin-bottom: 0.2rem;
`;
const Subtitle = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 1.05rem;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.3rem;
`;
const Card = styled.div`
  background: #fff5f5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(255, 0, 0, 0.06);
  padding: 1.2rem 1.1rem 1.1rem 1.1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-height: 110px;
`;
const IconWrap = styled.div`
  margin-top: 2px;
  color: #e53935;
  font-size: 1.7rem;
  flex-shrink: 0;
`;
const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const CardTitle = styled.div`
  font-weight: 600;
  color: #b71c1c;
  font-size: 1.08rem;
  margin-bottom: 0.2rem;
`;
const CardDesc = styled.div`
  color: #333;
  font-size: 0.98rem;
`;

const CommonPitfallsSection = () => (
  <SectionContainer>
    <h2 style={{ textAlign: 'center', color: 'var(--primary-color)', fontSize: '1.8rem', fontWeight: 700, marginBottom: '1.5rem' }}>Common Pitfalls & Guardrails</h2>
    <p style={{ textAlign: 'center', color: '#666', marginBottom: '1.5rem', fontSize: '1.05rem' }}>Mistakes to avoid when working with AI models</p>
    <Grid>
      {pitfalls.map((pit, i) => (
        <Card key={pit.title}>
          <IconWrap><MdWarningAmber /></IconWrap>
          <CardContent>
            <CardTitle>{pit.title}</CardTitle>
            <CardDesc>{pit.desc}</CardDesc>
          </CardContent>
        </Card>
      ))}
    </Grid>
  </SectionContainer>
);

export default CommonPitfallsSection; 